import styled from 'styled-components'

export const RecordedDataTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-top: 1rem;
  padding-bottom: 2rem;
`

export const RecordedDataTabControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  & label.controlLabel {
    font-size: 1rem;
    font-weight: 600;
  }
`

export const DurationControlContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const RangePickerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MewsChartsContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: 48% 48%;
  row-gap: 1.5rem;
  column-gap: 0.5rem;
`

export const PrintContainer = styled.div`
  width: 100%;
  max-width: 297mm; // A4 landscrape

  /* hide */
  height: 0;
  overflow: hidden;

  /* show when print */
  @media print {
    height: 100%;
    overflow: visible;
  }

  @page {
    margin: 1rem 0.5rem;
  }
`

export const PrintWrapper = styled.div`
  display: grid;
  gap: 1rem;
`

export const PrintMewsChartsContainer = styled.div`
  display: grid;
  width: 100%;
  padding-right: 3rem;
`

export const ChartTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 20px;
  padding-bottom: 20px;
`

export const TimeContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  padding: 0 1rem;
  text-align: start;
  & .timeLabel {
    font-size: 1rem;
    font-weight: 600;
  }
`

export const PatientDataContainer = styled.div`
  display: grid;
  gap: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 4px solid #000;
`

export const PatientDataContentContainer = styled.div`
  width: 100%;
  padding-left: 1rem;

  & h1 {
    font-size: 2rem;
    margin: 0;
  }

  & p {
    font-size: 1rem;
    margin: 0;
  }
`

const flexStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContents: 'center',
}

export const recordedDataRadioSizing = {
  small: {
    fontSize: '12px',
    width: '85px',
    height: '20px',
    margin: '0px',
    ...flexStyle,
  },
  middle: {
    fontSize: '16px',
    width: '120px',
    ...flexStyle,
  },
  large: {
    fontSize: '20px',
    width: '160px',
    ...flexStyle,
  },
}

export const ToolTipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: white;
  border: 1px solid rgb(204, 204, 204);
`

export const TooltipInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
  & strong {
    text-transform: capitalize;
    width: 60px;
    display: inline-block;
    position: relative;
    &::after {
      content: ':';
      position: absolute;
      right: 0px;
    }
  }
`

export const ModeControlContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 1rem;
  gap: 10px;
`

export const EcgContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const EcgChartsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  gap: 0.375rem;
  padding: 1rem;
`

export const EcgChartWrapper = styled.div`
  height: 15rem;
`

export const BreadcrumbContainer = styled.div`
  margin-right: auto;
  padding: 0 1rem;
`

export const EcgHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  font-size: 0.875rem;
  padding: 1rem;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 6rem;
  padding: 6rem;
  flex: 1;
  min-height: 32rem;
  border-radius: 0.25rem;
  border: 1px dashed #ccc;
`

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`

export const LoadingText = styled.p`
  font-size: 1.5rem;
`
